import { SearchFilterDTO, TextSearchFilterDTO, TextSearchFilterId } from "../../types";

const textSearchTypes: Record<TextSearchFilterId, true> = {
  "permitted-use-id": true,
  "proprietor-name": true,
  "owner-portfolio-text-filter-id": true,
  "owner-portfolio-address-text-filter-id": true,
};

export function isTextSearchDTO(filter: SearchFilterDTO): filter is TextSearchFilterDTO {
  return filter.id in textSearchTypes;
}
